import { FC, useContext, useEffect } from "react";

import { useRouter } from "next/router";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { ConsentModeContext } from "@/common/contexts/ConsentModeContext";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

const PAGE_TYPE_BY_ROUTE: Record<string, string> = {
  "/grant-finder": "home",
  "/grant-finder/grant-index": "grant_index",
  "/grant-finder/foundations/[ein]": "foundation_profile",
  "/grant-finder/funders/[funderId]": "funder_profile",
  "/grant-finder/grant-programs/[id]": "grant_program",
  "/grant-finder/grants/[slug]": "grants_lander",
};

export const GrantFinderPageViewTracker: FC = () => {
  const router = useRouter();
  const { logAmplitudeEvent } = useAmplitude();
  const { hasFunctionalityConsentMode } = useContext(ConsentModeContext);

  const path = router.asPath.split("?")[0];

  useEffect(() => {
    if (!hasFunctionalityConsentMode) {
      return;
    }
    logAmplitudeEvent(AmplitudeEvents.GrantFinderPageViewed, {
      path,
      page_type: PAGE_TYPE_BY_ROUTE[router.pathname] ?? "other",
      counter: getNextPageViewCount(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, hasFunctionalityConsentMode]);

  return null;
};

const PAGE_VIEW_COUNT_STORAGE_KEY = "grantFinderPageViewCount";

const getNextPageViewCount = (): number | undefined => {
  try {
    const previousCount = Number(window.sessionStorage.getItem(PAGE_VIEW_COUNT_STORAGE_KEY)) || 0;
    const nextCount = previousCount + 1;
    window.sessionStorage.setItem(PAGE_VIEW_COUNT_STORAGE_KEY, String(nextCount));
    return nextCount;
  } catch {
    return undefined;
  }
};
